import React from "react";
import { ArrowRight, FileDown } from "lucide-react";

const SAMPLE_SOA_URL =
  "https://docs.google.com/document/d/10cmFaykQbqo0TsE2U4chucZM1L1N2Ype/edit?usp=drive_link";

const goBook = (e) => {
  e.preventDefault();
  document.querySelector("#booking")?.scrollIntoView({ behavior: "smooth" });
};

const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative bg-black text-white border-b-2 border-black overflow-hidden"
    >
      <div className="absolute -top-16 -right-16 w-72 h-72 bg-[#FACC15] border-2 border-[#FACC15] rotate-12" aria-hidden />
      <div className="absolute -bottom-20 -left-20 w-72 h-72 border-2 border-[#FACC15] rotate-12" aria-hidden />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <span className="inline-block bg-[#FACC15] text-black border-2 border-[#FACC15] px-3 py-1 text-xs font-bold uppercase tracking-widest">
            Ready when you are
          </span>
          <h2 className="font-display font-black mt-4 text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.0]">
            Ready to clear your advice backlog?
          </h2>
          <p className="mt-5 text-base md:text-lg text-white/80 max-w-2xl leading-relaxed">
            Let&apos;s streamline your practice. Review the sample SOA, or start with a low-risk
            <strong className="text-[#FACC15]"> $150 trial</strong> today.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href="#booking"
              onClick={goBook}
              data-testid="final-cta-book"
              className="inline-flex items-center justify-center gap-2 bg-[#FACC15] text-black border-2 border-[#FACC15] font-bold uppercase text-sm tracking-wide py-4 px-7 hover:translate-y-[-2px] transition-transform"
            >
              Book $150 Trial SOA <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href={SAMPLE_SOA_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-sample"
              className="inline-flex items-center justify-center gap-2 bg-black text-white border-2 border-white font-bold uppercase text-sm tracking-wide py-4 px-7 hover:bg-white hover:text-black transition-colors"
            >
              <FileDown className="w-4 h-4" /> Download Sample Portfolio
            </a>
          </div>
        </div>

        <div className="lg:col-span-4">
          <div className="bg-[#FACC15] text-black border-2 border-[#FACC15] p-6 shadow-brutal">
            <p className="text-xs font-bold uppercase tracking-widest">By the numbers</p>
            <ul className="mt-3 grid grid-cols-2 gap-3">
              <li>
                <p className="font-display font-black text-3xl leading-none">1,100+</p>
                <p className="text-[10px] font-bold uppercase tracking-widest mt-1">Documents delivered</p>
              </li>
              <li>
                <p className="font-display font-black text-3xl leading-none">$200M+</p>
                <p className="text-[10px] font-bold uppercase tracking-widest mt-1">FUM practices served</p>
              </li>
              <li>
                <p className="font-display font-black text-3xl leading-none">5+</p>
                <p className="text-[10px] font-bold uppercase tracking-widest mt-1">Years AU experience</p>
              </li>
              <li>
                <p className="font-display font-black text-3xl leading-none">0</p>
                <p className="text-[10px] font-bold uppercase tracking-widest mt-1">Retainer fees</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
